/*------------------------------------*\
    WEIGHT FILTER COLLAPSE
\*------------------------------------*/
class WeightFilter {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggle = self.elem.querySelector('[data-weight-filter-toggle]');
        self.nav = self.elem.querySelector('[data-weight-filter-nav]');
    }

    init() {
        let self = this;

        self.toggle.addEventListener('click', (evt) => {
            evt.preventDefault();

            self.nav.classList.toggle('show');
            self.toggle.classList.toggle('collapsed');
            self.elem.classList.toggle('open');

        });
    }
}

export default WeightFilter;